module.exports = __webpack_public_path__ + "7c9add1f56f91092fd1c14b2fb9100c9.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_analytics/icons/comment.png
// module id = 471
// module chunks = 69